import { render } from "./RouteProxy.vue?vue&type=template&id=d5da4a64&lang=pug"
const script = {}

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__